var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOutIcon = function SvgZoomOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H6Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18a8.96 8.96 0 0 0 5.215-1.664l.02.02 4.394 4.394a1.5 1.5 0 1 0 2.12-2.121l-4.393-4.395-.02-.019A9 9 0 1 0 9 18Zm0-1.8A7.2 7.2 0 1 0 9 1.8a7.2 7.2 0 0 0 0 14.4Z",
    fill: "#455A64"
  })));
};
export default SvgZoomOutIcon;